export default {
  addTalent: ({ commit }, payload) => commit('ADD_TALENT', payload),
}